import { request as _request, updateRequestConfig } from './request';

/**
 * 获取红包列表
 * @returns
 */
const getRedPacketList = params => {
  return _request({
    url: `/v3/vss/red-packet/list`,
    method: 'get',
    params
  });
};
/**
 * 获取红包详情
 * @returns
 */
const getRedPacketInfo = params => {
  return _request({
    url: `/v3/vss/red-packet/info`,
    method: 'get',
    params
  });
};

/**
 * 创建红包
 */
const createRedPacket = params => {
  return _request({
    url: `/v3/vss/red-packet/add`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

/**
 * 编辑红包
 */
const editRedPacket = params => {
  return _request({
    url: `/v3/vss/red-packet/edit`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

/**
 * 删除红包
 */
const delRedPacket = params => {
  return _request({
    url: `/v3/vss/red-packet/batch-delete`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 推送红包
 */
const pushRedPacket = params => {
  return _request({
    url: `/v3/vss/red-packet/push`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 推送红包
 */
const endRedPacket = params => {
  return _request({
    url: `/v3/vss/red-packet/end`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
/**
 * 领取红包用户记录
 */
const getRcordList = params => {
  return _request({
    url: `/v3/vss/red-packet/record/list`,
    method: 'get',
    params
  });
};
//导出红包领取记录
const exportRcord = params => {
  return _request({
    url: `/v3/vss/red-packet/record/export`,
    method: 'post',
    params,
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};
// 统一导入API
export {
  getRedPacketList,
  getRedPacketInfo,
  createRedPacket,
  editRedPacket,
  delRedPacket,
  pushRedPacket,
  endRedPacket,
  getRcordList,
  exportRcord
};
